import { store } from './../store'

export const MEDIA_LOAD_START  = 'MEDIA_LOAD_START'
export const MEDIA_LOAD_COMPLETE  = 'MEDIA_LOAD_COMPLETE'
export const OFFCANVAS_SHOW  = 'OFFCANVAS_SHOW'
export const OFFCANVAS_HIDE  = 'OFFCANVAS_HIDE'


export const mediaLoadStart = (payload) => {
  store.dispatch({type: MEDIA_LOAD_START, payload})
}
export const mediaLoadComplete = (payload) => {
  store.dispatch({type: MEDIA_LOAD_COMPLETE, payload})
}
export const offcanvasShow = () => {
  store.dispatch({type: OFFCANVAS_SHOW})
}
export const offcanvasHide = () => {
  store.dispatch({type: OFFCANVAS_HIDE})
}